import { render, staticRenderFns } from "./template_add.vue?vue&type=template&id=5af45c4a&scoped=true&"
import script from "./template_add.vue?vue&type=script&lang=js&"
export * from "./template_add.vue?vue&type=script&lang=js&"
import style0 from "./template_add.vue?vue&type=style&index=0&id=5af45c4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af45c4a",
  null
  
)

export default component.exports